import React from 'react';
import SignUp from '../components/SignUp';
import SignUpImg from "../assets/signup_img.png"

const SignUpPage = () => {
  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <img
        src={SignUpImg}
        alt="Background"
        style={{ width: '70%', objectFit: 'cover' }}
      />
      <SignUp />
    </div>
  );
};

export default SignUpPage;
